import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import LinearProgress from '@material-ui/core/LinearProgress';

import DataBase from './components/DataBase';
import Footer from './components/Footer';
import Updates from './components/Updates';
import { _Database } from './base';

const useStyles = makeStyles(theme => ({
  logo: {
    width: '100%',
    maxWidth: 380
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  bookTitle: {
    fontSize: 'inherit'
  }
}));

function App() {
  const classes = useStyles();
  const [database, setDatabase] = useState(false);
  const [updates, setUpdates] = useState(false);

  useEffect(() => {
    _Database.ref('/Data').once('value').then(snapshot => setDatabase(snapshot.val()));
    _Database.ref('/DataUpdates').once('value').then(snapshot => setUpdates(snapshot.val()));

    return () => {
      setDatabase(false);
      setUpdates(false);
    }
  }, [])

  return (
    <Fragment>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>
          <Typography variant="h6" color="secondary">Data Hodor!</Typography>
        </Toolbar>
      </AppBar>
      <main>
        <div className={classes.heroContent}>
          <Container maxWidth="sm">
            <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
              <img src="images/hodor-logo.png" alt="Hodor Cavalo" className={classes.logo} />
            </Typography>
            <Typography variant="h5" align="center" color="textSecondary" paragraph>
              Os dados mais importantes, ou não <span role="img" aria-label="smile">🙂</span>,
              do melhor podcast sobre <Typography className={classes.bookTitle} component="span" color="secondary">As Crônicas de Gelo e Fogo</Typography>.
            </Typography>
          </Container>
        </div>
        { database && <DataBase database={database}/> }
      </main>
      { updates && <Updates updates={updates} /> }
      { !database && !updates && <LinearProgress color="secondary" /> }
      <Footer />
    </Fragment>
  );
}

export default App;